var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 5.36133C9.46351 5.36133 8.9575 5.88554 8.57657 6.26647L3.84619 10.9991V16.4243C3.84619 17.0178 4.32833 17.5 4.92303 17.5H15.0797C15.6733 17.5 16.1554 17.0178 16.1554 16.4243V10.9991L11.4239 6.26647C11.0441 5.88554 10.5369 5.36133 10.0002 5.36133ZM13.2831 13.3666H11.1055V15.5441H8.89496V13.3666H6.71626V11.1572H8.89496V8.97847H11.1055V11.1572H13.2831V13.3666Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7065 8.80044L12.3416 3.43897C11.0897 2.18701 8.91098 2.18701 7.65675 3.43897L2.29528 8.80044C1.95301 9.14271 1.95301 9.69535 2.29528 10.0388C2.62504 10.3685 3.20155 10.3685 3.53132 10.0388L8.89393 4.67501C9.48522 4.08371 10.5154 4.08371 11.1056 4.67501L16.4682 10.0388C16.6331 10.2036 16.8537 10.2935 17.0857 10.2935C17.3188 10.2935 17.5394 10.2036 17.7065 10.0388C18.0477 9.69535 18.0477 9.14271 17.7065 8.80044Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClinic);
export default __webpack_public_path__ + "static/media/icon-clinic.d0dc99156b27feffb896a66d30fa5955.svg";
export { ForwardRef as ReactComponent };